<template>
<div class="ad-item" @click="handleClick" ref="adWrap" v-exposure="data">
	<header class="line-cut">
		<a href="javascript:;">{{ data.title }}</a>
		<span class="ad-tip"></span>
	</header>
	<img :src="data.img" alt="">
</div>
</template>

<script>
import { adClickCount } from '../api/ad360'
export default {
	name: 'Ad360',
	props: {
		data: {
			type: Object,
			default: {}
		}
	},
	methods: {
		handleClick(e) {
			// 获取宽高
			const rect = this.$refs.adWrap.getBoundingClientRect()
			const offset_x = Math.floor(e.pageX - rect.left)
			const offset_y = Math.floor(e.pageY - rect.top)
			const w = Math.floor(rect.width)
			const h = Math.floor(rect.height)
			adClickCount(this.data.curl, this.data.clktk, offset_x, offset_y, w, h)
		}
	}
}
</script>

<style scoped>
.ad-item {
	cursor: pointer;
}

.ad-item:hover header {
	color: #167ed9;
}

.ad-item:hover header a {
	color: #167ed9;
	text-decoration: underline;
}

header {
	align-items: center;
	width: 100%;
	padding-right: 30px;
	box-sizing: border-box;
	position: relative;
}

header a  {
	color: #333;
	text-decoration: none;
	font-size: 14px;
	line-height: 18px;
}

header .ad-tip {
	position: absolute;
	right: 0px;
	top: 6px;
	display: block;
	width: 22px;
	height: 12px;
	background: url(../images/ad-tip.png);
}

img {
	display: block;
	width: 100%;
	margin-top: 10px;
	font-size: 0px;
}

</style>
